import { useParams } from "react-router-dom"
import {retrieveTodoApi , updateTodoApi, createTodoApi} from './api/TodoApiService'
import {  useAuth } from './security/AuthContext'
import {useEffect, useState} from 'react'
import {Formik , Form , Field, ErrorMessage} from 'formik'
import { useNavigate} from 'react-router-dom'
import {addTodoReducer,updateTdoAction} from '../../redux/todosReducer'
import { useDispatch, useSelector } from "react-redux";

export default function TodoComponent(){

   const {id} = useParams()
   const authContext = useAuth() 
   const username = authContext.username
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const[description,setDescription] = useState('')
   const[targetDate,setTargetDate] = useState('')
   const { ids } = useSelector((state) => state.counter);
   const { count } = useSelector((state) => state.counter);


useEffect(
    () =>
    retrieveTodos(),[id]
)

function findTodo  (array,id)  {
   
    return array.find(person => person.id.toString() === id);
  };



  
   function retrieveTodos(){

const todo = findTodo(count,id)

  
    if( id!= -1){
    retrieveTodoApi(username, id)
    .then(
         response => {console.log(response)
         setDescription(response.data.description)
         setTargetDate(response.data.targetDate)
          } )
.catch( () => {
    setDescription(todo.description)
    setTargetDate(todo.targetDate)
})}

   }

   function onSubmit(values){
    var todo= {
        id: id,
        username : username,
        description: values.description,
        targetDate: values.targetDate,
        done : false
    }

    if(id != -1){
    updateTodoApi(username,id,todo)
    .then( 
         response => {
            console.log(response)
            navigate(`../todos`)
         } )
    .catch(
    dispatch(updateTdoAction(todo)),
    navigate(`../todos`)
    )
   console.log(values)
        }else{

            createTodoApi(username,todo)
            .then( 
                response => {
                   console.log(response.data)
                  
              //     navigate(`../../todos`)
              navigate(`../todos`)
                } )
                .catch(  
                todo= {
                    id: ids+1,
                    username : username,
                    description: values.description,
                    targetDate: values.targetDate,
                    done : false
                },
                dispatch(addTodoReducer(todo)),
                navigate(`../todos`)
                
                )
        }
}

function validate(values){
    console.log(values.targetDate)
    let errors = {
        // description: 'Enter a valid description',
        // targetDate: 'Enter a valid target date'
    }

    if(values.description.length <5 ){
        errors.description ='Enter alleast 5 charachters'
    }

    if(values.targetDate == null || values.targetDate == ""){
        errors.targetDate='Enter a target Date'
        console.log("no date")
        console.log(values.targetDate)
       
    }


    console.log(values)
    return errors
}

    return(
        <div className="container">
            <div>
                <h1>Enter Todo Details</h1>
                <div>
<Formik  initialValues= {{description,targetDate}}
enableReinitialize={true}
onSubmit={onSubmit}
validate= {validate}
validateOnChange={false}
validateOnBlur={false}
>
    {
       (props)  => (
        <Form >
            <ErrorMessage 
            name="description"
            component="div"
            className="alert alert-warning"
            />
            <ErrorMessage 
            name="targetDate"
            component="div"
            className="alert alert-warning"
            />
            
<fieldset className="form-group">
    <label>
Description
    </label>
    <Field type="text" className="form-control" name="description"/>
</fieldset>

<fieldset className="form-group">
    <label>
Target Date
    </label>
    <Field type="date" className="form-control" name="targetDate"/>
</fieldset>
<div>
    <button className="btn btn-success m-5" type="submit">Save</button>
</div>
</Form>
       )
    }


</Formik>
                </div>

</div>
        </div>
    )
}